import { html, TemplateResult } from 'lit';

export class MultipleValueUtils {
  static getMultipleValueCounter(length: number): TemplateResult {
    return html`<span class="multiple-value__counter">+${length}</span>`;
  }

  static getActionButtonTemplate(icon: string): TemplateResult {
    return html` <gz-icon-button
      class="action-btn"
      icon="${icon}"
      buttonType="round"
      buttonFill="quiet"
      buttonColor="secondary"
      size="18"
      fontSize="8"
    ></gz-icon-button>`;
  }

  static getValueTemplate(
    displayValue: string,
    actionTemplate: TemplateResult,
    valueCounter: TemplateResult | string = ''
  ): TemplateResult {
    return html`
      <span class="multiple-value-container">
        <div class="multiple-value__text">${displayValue}</div>
        ${valueCounter}
        <span class="action-template-container"> ${actionTemplate} </span>
      </span>
    `;
  }
}
